export class SamplingSimulationRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sampling",
            "baseName": "sampling",
            "type": "NativeStreamSamplingConfig",
            "format": ""
        },
        {
            "name": "targetScanRows",
            "baseName": "targetScanRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "topSegments",
            "baseName": "topSegments",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SamplingSimulationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
